import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export function HiddenLimit(props) {
    const { className } = props;
    return _jsx("div", { className: classNames(className), children: "Limits are defined by your active license" });
}
